module.exports = __webpack_public_path__ + "img/FR12128.e0796a2d.png";